import React from "react";
import { withStyles } from "@material-ui/core/styles";
import logoSF from "../../assets/S&F_EN_LOGO_BLANC.png";
import logoR from "../../assets/edf-renouvelables.png";

const styles = theme => ({
  root: {
    display: 'inline-block',
    verticalAlign: 'bottom',
    color: '#FFFFFF'
  },
  by: {
    display: 'inline-block',
    verticalAlign: 'bottom',
    margin: '0 .5em 3px 1em',
    fontSize: '.7em'
  },
  logo: {
    display: 'inline-block',
    verticalAlign: 'bottom',
    height: 30
  }
});

function ByEdfSf(props) {
  const { classes } = props;

  return (
    <React.Fragment>
      <a
        href="https://edf-sf.com/"
        target="_blank"
        className={classes.root}
        title="by EDF store & forecast. EDF group (new window)"
      >
        <div className={classes.by}>by</div>
        <img
          src={logoSF}
          alt="EDF store & forecast. EDF group"
          className={classes.logo}
        />
      </a>
      <a
        href="https://www.edf-renouvelables.com/"
        target="_blank"
        className={classes.root}
        title="EDF renouvelables (new window)"
      >
        <div className={classes.by}>and</div>
        <img
          src={logoR}
          alt="EDF renouvelables"
          className={classes.logo}
        />
      </a>
    </React.Fragment>
  );
}

export default withStyles(styles)(ByEdfSf);



// WEBPACK FOOTER //
// ./src/components/common/byEdfSf.js